"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.distributorMap = void 0;
const js_api_loader_1 = require("@googlemaps/js-api-loader");
const splide_1 = __importDefault(require("@splidejs/splide"));
const distributorMap = () => {
    let mapEl = document.querySelector('[data-map="distributors"]');
    if (!mapEl) {
        return;
    }
    let distInfoEl = document.getElementById('distributors-info-carousel');
    let distAddressEl = document.getElementById('distributors-address-carousel');
    if (!distInfoEl || !distAddressEl) {
        return;
    }
    const updateDistributors = (destIndex) => {
        let allVLs = document.getElementsByClassName('distributors__vehicles-list');
        for (let i = 0; i < allVLs.length; i++) {
            allVLs[i].setAttribute('aria-hidden', 'true');
        }
        let currentVL = document.getElementById('dvl-' + (destIndex + 1));
        currentVL.setAttribute('aria-hidden', 'false');
    };
    let distInfo = new splide_1.default(distInfoEl, {
        perPage: 1,
        type: 'loop',
        pagination: true,
        autoplay: false,
        arrows: false,
    });
    distInfo.on('mounted', () => {
        updateDistributors(0);
    });
    distInfo.on('move', function (destIndex) {
        updateDistributors(destIndex);
    });
    let distAddress = new splide_1.default(distAddressEl, {
        perPage: 3,
        gap: 24,
        pagination: false,
        padding: { left: 0, right: 0 },
        isNavigation: true,
        autoplay: false,
        arrows: false,
        breakpoints: {
            1023: {
                perPage: 2,
                gap: '1rem',
            },
            767: {
                perPage: 1,
                padding: { left: 64, right: 64 },
                gap: '1rem',
            },
        }
    });
    distInfo.sync(distAddress);
    distInfo.mount();
    distAddress.mount();
    const loader = new js_api_loader_1.Loader({
        apiKey: 'AIzaSyDk8ZOUVmYmxkQPM42Pf8vxGK_vYzfqYyM'
    });
    loader.loadCallback(e => {
        if (e) {
            console.log(e);
        }
        else {
            let distributors = JSON.parse(mapEl.getAttribute('data-distributors'));
            const map = new google.maps.Map(mapEl, {
                // get lat and lng for norwich, uk
                center: new google.maps.LatLng(51.986258, -1.520262),
                zoom: 7,
                disableDefaultUI: true,
                zoomControl: true
                // gestureHandling: 'cooperative'
            });
            let markers = [];
            let windows = [];
            let bounds = new google.maps.LatLngBounds();
            Object.keys(distributors).forEach(function (i, key) {
                const lat = parseFloat(distributors[i].lat);
                const lng = parseFloat(distributors[i].lng);
                markers.push(new google.maps.Marker({
                    position: { lat, lng }
                }));
                if (markers[key]) {
                    markers[key].setMap(map);
                    bounds.extend(markers[key].getPosition());
                    windows.push(new google.maps.InfoWindow({
                        ariaLabel: distributors[i].title,
                        content: `<div class="distributors__window">
                  <h3 class="size-m uppercase pt-50 pb-25 pl-75 pr-75">${distributors[i].title}</h3>
                  <address class="pl-75 pr-75 pb-50 size-1rem color-grey-m flow-50 mt-100">
                  ${distributors[i].address}<br>
                  <strong class="block">T: ${distributors[i].telephone}</strong>
                  </address>
               </div>`
                    }));
                    markers[key].addListener('click', () => {
                        windows[key].open(map, markers[key]);
                        distInfo.go(key);
                        const otherWindows = windows.filter((window, index) => index !== key);
                        otherWindows.forEach((window) => {
                            window.close();
                        });
                    });
                }
            });
            map.fitBounds(bounds);
        }
    });
};
exports.distributorMap = distributorMap;
